/* =========================================================
   MADSPEED7 — CANDYRACK CART VARIANT SELECTOR
   ========================================================= */

(function () {

  function initialiseVariantSelectors() {

    const container = document.querySelector(
      '#candyrack-slider-cart'
    );

    if (!container) return;

    const offers = container.querySelectorAll(
      '.candyrack-slider-cart-offer-item-wrapper'
    );

    offers.forEach(function (offer) {

      const select = offer.querySelector(
        '.candyrack-slider-cart-offer-item-variant-select select'
      );

      const button = offer.querySelector(
        '.candyrack-slider-cart-offer-item-add-button'
      );

      const priceWrapper = offer.querySelector(
        '.candyrack-slider-cart-offer-price-wrapper'
      );

      if (!select || !button) return;

      /* Already initialised */
      if (select.dataset.ms7VariantSetup === 'true') return;

      /* Create Select Option */
      const placeholder = document.createElement('option');

      placeholder.value = '';
      placeholder.textContent = 'Select Option';

      select.insertBefore(
        placeholder,
        select.firstChild
      );

      /* Start with no option selected */
      select.value = '';

      /* Show Select Option in Candy Rack's visible selector */
      const handleLabel = offer.querySelector(
        '.VariantSelector_selectHandleLabel__1twtrs06'
      );

      if (handleLabel) {
        handleLabel.textContent = 'Select Option';
      }

      /* Show From before the price */
      if (priceWrapper) {

        const fromLabel =
          document.createElement('span');

        fromLabel.className =
          'ms7-candyrack-from-label';

        fromLabel.textContent = 'From ';

        priceWrapper.insertBefore(
          fromLabel,
          priceWrapper.firstChild
        );

      }

      /* Disable Add button */
      button.disabled = true;

      /* Enable Add after customer selects an option */
      select.addEventListener('change', function () {

        const hasSelection =
          select.value !== '';

        button.disabled =
          !hasSelection;

        /* Disable "Select Option" once a real variant is selected */
        placeholder.disabled =
          hasSelection;

        const selectedOption =
          select.options[select.selectedIndex];

        if (handleLabel && selectedOption) {
          handleLabel.textContent =
            selectedOption.textContent;
        }

        /* Remove From once a variant is selected */
        if (hasSelection && priceWrapper) {

          const fromLabel =
            priceWrapper.querySelector(
              '.ms7-candyrack-from-label'
            );

          if (fromLabel) {
            fromLabel.remove();
          }

        }

      });

      select.dataset.ms7VariantSetup = 'true';

    });

  }

  /* Candy Rack loads dynamically */
  const observer = new MutationObserver(function () {

    initialiseVariantSelectors();

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* Initial check */
  initialiseVariantSelectors();

})();


/* =========================================
   CandyRack Cart Drawer
   Single available variant dropdown fallback
   Show all variants, including sold out
   ========================================= */

(function () {

  function getProductHandle(card) {

    const link =
      card.querySelector('a[href*="/products/"]');

    if (!link) return null;

    const match =
      link.getAttribute('href')
        .match(/\/products\/([^/?#]+)/);

    return match ? match[1] : null;

  }

  function setButtonState(button, enabled) {

    if (!button) return;

    button.disabled =
      !enabled;

    button.style.opacity =
      enabled ? '1' : '0.5';

    button.style.pointerEvents =
      enabled ? 'auto' : 'none';

  }

  async function addSingleVariantDropdown(card) {

    if (!card) return;

    /* Prevent duplicate injections */
    if (
      card.dataset.whSingleVariantFallback === 'true'
    ) return;

    if (
      card.dataset.whSingleVariantFallbackLoading === 'true'
    ) return;

    if (
      card.querySelector(
        '.wh-single-variant-fallback'
      )
    ) return;

    card.dataset.whSingleVariantFallbackLoading =
      'true';

    const handle =
      getProductHandle(card);

    if (!handle) {

      card.dataset.whSingleVariantFallbackLoading =
        '';

      return;

    }

    const titleWrapper =
      card.querySelector(
        '.candyrack-slider-cart-offer-item-title-wrapper'
      );

    const button =
      card.querySelector(
        '.candyrack-slider-cart-offer-item-add-button'
      );

    if (!titleWrapper || !button) {

      card.dataset.whSingleVariantFallbackLoading =
        '';

      return;

    }

    try {

      const res =
        await fetch(
          '/products/' + handle + '.js',
          {
            credentials: 'same-origin'
          }
        );

      if (!res.ok) {

        card.dataset.whSingleVariantFallbackLoading =
          '';

        return;

      }

      const product =
        await res.json();

      if (
        !product ||
        !product.variants ||
        product.variants.length <= 1
      ) {

        card.dataset.whSingleVariantFallbackLoading =
          '';

        return;

      }

      const availableVariants =
        product.variants.filter(function (variant) {
          return variant.available;
        });

      /*
       Only use this fallback when exactly
       one variant is available.
      */
      if (availableVariants.length !== 1) {

        card.dataset.whSingleVariantFallbackLoading =
          '';

        return;

      }

      const availableVariant =
        availableVariants[0];

      /* Remove any accidental previous fallback */
      card
        .querySelectorAll(
          '.wh-single-variant-fallback'
        )
        .forEach(function (el) {
          el.remove();
        });

      const wrapper =
        document.createElement('div');

      wrapper.className =
        'VariantSelector_selectWrapper__1twtrs00 ' +
        'candyrack-slider-cart-offer-item-variant-select ' +
        'wh-single-variant-fallback';

      /*
       Create ALL variants.

       Available variant:
       normal option

       Unavailable variants:
       visible but disabled + Sold out
      */

      const optionsHtml =
        product.variants
          .map(function (variant) {

            const soldOutText =
              variant.available
                ? ''
                : ' – Sold out';

            return `
              <option
                value="${variant.id}"
                ${variant.available ? '' : 'disabled'}
              >${variant.title}${soldOutText}</option>
            `;

          })
          .join('');

      wrapper.innerHTML = `
        <div class="VariantSelector_selectHandle__1twtrs04">

          <span class="VariantSelector_selectHandleLabel__1twtrs06">
            Select Option
          </span>

          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            class="VariantSelector_selectHandleIcon__1twtrs03"
          >
            <path d="M14.7789 8.90533C15.0718 8.61244 15.0718 8.13756 14.7789 7.84467C14.486 7.55178 14.0111 7.55178 13.7182 7.84467L9.99927 11.5636L6.28033 7.84467C5.98744 7.55178 5.51256 7.55178 5.21967 7.84467C4.92678 8.13756 4.92678 8.61244 5.21967 8.90533L9.44703 13.1327C9.454 13.1403 9.46116 13.1477 9.4685 13.155C9.61563 13.3022 9.80868 13.3754 10.0015 13.3747C10.1929 13.3743 10.3841 13.301 10.53 13.155C10.5374 13.1477 10.5445 13.1403 10.5374 13.1477L10.5515 13.1327L14.7789 8.90533C15.0718 8.61244 15.0718 8.13756 14.7789 7.84467Z"></path>
          </svg>

        </div>

        <select
          class="VariantSelector_selectTag__1twtrs02 wh-single-variant-select"
        >

          <option value="">
            Select Option
          </option>

          ${optionsHtml}

        </select>
      `;

      titleWrapper.appendChild(wrapper);

      const select =
        wrapper.querySelector('select');

      const label =
        wrapper.querySelector(
          '.VariantSelector_selectHandleLabel__1twtrs06'
        );

      /*
       IMPORTANT:
       This selector has already been set up
       by our fallback.

       Prevent the normal selector script
       from adding another Select Option.
      */
      select.dataset.ms7VariantSetup =
        'true';

      /* Start disabled */
      setButtonState(
        button,
        false
      );

      /*
       Handle selection
      */
      select.addEventListener(
        'change',
        function () {

          const selectedVariant =
            product.variants.find(
              function (variant) {

                return String(variant.id) ===
                  String(select.value);

              }
            );

          if (
            !selectedVariant ||
            !selectedVariant.available
          ) {

            label.textContent =
              'Select Option';

            setButtonState(
              button,
              false
            );

            return;

          }

          /*
           Keep Select Option visible,
           but disable it after a real
           variant has been selected.
          */
          const placeholder =
            select.querySelector(
              'option[value=""]'
            );

          if (placeholder) {
            placeholder.disabled = true;
          }

          label.textContent =
            selectedVariant.title;

          setButtonState(
            button,
            true
          );

        }
      );

      card.dataset.whSingleVariantFallback =
        'true';

      card.dataset.whSingleVariantFallbackLoading =
        '';

    } catch (e) {

      card.dataset.whSingleVariantFallbackLoading =
        '';

    }

  }

  function initSingleVariantFallbacks() {

    const drawer =
      document.getElementById(
        'candyrack-slider-cart'
      );

    if (!drawer) return;

    drawer
      .querySelectorAll(
        '.candyrack-slider-cart-offer-item-wrapper'
      )
      .forEach(
        addSingleVariantDropdown
      );

  }

  setTimeout(
    initSingleVariantFallbacks,
    500
  );

  setTimeout(
    initSingleVariantFallbacks,
    1500
  );

  setTimeout(
    initSingleVariantFallbacks,
    3000
  );

  const observer =
    new MutationObserver(
      initSingleVariantFallbacks
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();


/* =========================================
   CandyRack Cart Drawer – Force Small Title
   ========================================= */

(function () {

  function applyCandyRackTitleSize() {

    document
      .querySelectorAll(
        'a.candyrack-slider-cart-offer-item-header'
      )
      .forEach(function (title) {

        title.style.setProperty(
          'font-size',
          '14px',
          'important'
        );

        title.style.setProperty(
          'line-height',
          '1.4',
          'important'
        );

        title.style.setProperty(
          'font-weight',
          '550',
          'important'
        );

      });

  }

  applyCandyRackTitleSize();

  const observer =
    new MutationObserver(
      applyCandyRackTitleSize
    );

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(
    applyCandyRackTitleSize,
    500
  );

  setTimeout(
    applyCandyRackTitleSize,
    1500
  );

  setTimeout(
    applyCandyRackTitleSize,
    3000
  );

})();